import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const VscodeSessionGate = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const user = useAppSelector(selectUser);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (!user) {
    let to = `/auth/login`;
    const company = searchParams.get('company');

    if (company) {
      to += `?company=${company}`;
    }

    return <Navigate to={to} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
